<template>
  <page :basic="!client.is_owner">
    <owner-sidebar v-if="client.is_owner" slot="sidebar"/>
    <span slot="header">Your Profile</span>
    <email-needs-confirmation v-if="!client.is_confirmed"/>
    <settings/>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import emailNeedsConfirmation from './email-needs-confirmation'
import ownerSidebar from '../../sidebar/owner'
import page from '../../templates/page'
import settings from './settings'

export default {
  components: {
    emailNeedsConfirmation,
    ownerSidebar,
    page,
    settings
  },
  computed: {
    ...mapState('client', {
      client: 'data'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/profile/index.vue